import { BFFPageData } from '../../services/serviceClients/BffClient'
import { ShortProductTileV2 } from '../../types/TemplateConfiguration'
import PageDataUtil from '../pageDataUtil/pageDataUtil'
import { PageAvailabilityHandler } from '../productTileCollection/PageAvailabilityHandler'
import { ProductTileModel, ProductTileV2 } from '../productTileCollection/productTileCollection'
import { ProductTileV2DataExtractor } from '../productTileCollection/ProductTileV2DataExtractor'
import { MpvTileBuilder } from './MpvTileBuilder'

/**
 * Builds product tiles for grid layout sections
 */
export class GridTileBuilder {
  constructor(private readonly pageDataFromBFF: BFFPageData) {}

  /**
   * Builds a complete tile model from grid item
   */
  buildTile(item: ProductTileModel): ProductTileModel | undefined {
    const tileTemplate = (item.product as ShortProductTileV2)?.template
    if (!tileTemplate) return undefined

    const mpvId = tileTemplate.productsList?.selectedProduct?.mpvId

    if (!mpvId) {
      return {
        ...item,
        associatedPageAvailable: true
      }
    }

    return this.buildMpvTile(item, mpvId, tileTemplate)
  }

  private buildMpvTile(
    item: ProductTileModel,
    mpvId: string,
    tileTemplate: ProductTileV2
  ): ProductTileModel | undefined {
    const serverSideMpvData = PageDataUtil.getMpv(mpvId, this.pageDataFromBFF)

    if (!serverSideMpvData) {
      return undefined
    }

    const mpvTile = MpvTileBuilder.buildFromMpv(mpvId, serverSideMpvData)
    const associatedPageAvailable = PageAvailabilityHandler.isAvailable(
      mpvId,
      this.pageDataFromBFF.pageAvailabilities,
      ProductTileV2DataExtractor.hasExplicitLink(tileTemplate)
    )

    return {
      ...mpvTile,
      ...item,
      mpvId,
      associatedPageAvailable
    }
  }
}
